import { render, staticRenderFns } from "./StyledTextBlock.vue?vue&type=template&id=b6c18ad4&"
import script from "./StyledTextBlock.vue?vue&type=script&lang=js&"
export * from "./StyledTextBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports